<template>
    <section class="modal-mask superadmin-modal superadmin-custom-form">
        <div class="modal-wrapper">
            <div class="modal-container" v-click-outside="closeOpenModal">
                <div class="modal-body">
                    <h2>{{ title }}</h2>

                    <Warning v-if="!!warning" :message="warning"/>

                    <Languages v-if="!!languages" :languageList="languages" @selectedLanguageCode="updateSelectedLanguage($event)"/>

                    <div v-for="(field, fieldIndex) in fields" :key="fieldIndex">
                        <div class="label">
                            <span>{{ field.label }}</span>

                            <InfoIconWithLabel v-if="field.labelInfo" :labelInfo="field.labelInfo" label-position="bottom"/>
                        </div>

                        <Textarea
                            v-if="field.type === 'textarea-editor'"
                            :text="values[selectedLang ? selectedLang : field.code]"
                            @updatePassedValue="values[selectedLang ? selectedLang : field.code] = $event"
                        />

                        <textarea v-else-if="field.type === 'textarea'" :id="field.code" v-model="values[selectedLang ? selectedLang : field.code]"></textarea>
                        <input v-else :type="!!field.type ? field.type : 'text'"
                               :id="field.code" @focus="removeInputRequired(field.code)"
                               v-model="values[selectedLang ? selectedLang : field.code]" />
                    </div>
                </div>
                <div class="modal-footer">
                    <CustomButton :buttonType="buttonSettings.type" :buttonText="buttonSettings.text" :callback="checkRequiredFields"/>

                    <CustomButton buttonType="close" :callback="closeOpenModal"/>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import CustomButton from "./CustomButton";
    import Warning from "./Warning";
    import Languages from "./Languages";
    import InfoIconWithLabel from "./InfoIconWithLabel";
    import Textarea from "@/components/superadmin/ux/Textarea";

    export default {
        name: "SuperAdminCustomForm",
        components: {Textarea, InfoIconWithLabel, Languages, Warning, CustomButton },
        props: {
            title: String,
            fields: Array,
            languages: Object,
            existingValue: [String, Object],
            buttonSettings: {
                type: Object,
                default: () => {
                    return {
                        type: undefined,
                    }
                }
            },
        },
        data() {
            return {
                warning: '',
                selectedLang: null,
                values: this.existingValue || {},
            }
        },
        methods: {
            updateSelectedLanguage(lang) {
                this.selectedLang = lang;
            },

            checkRequiredFields() {
                const emptyRequiredInputs = [];
                Object.values(this.fields).filter(field => {
                    if (!!this.selectedLang) {
                        this.languages.map(lang => {
                            if (!this.values[lang.code] && field.required !== false) emptyRequiredInputs.push(field.code);
                        })
                    } else if (!this.values[field.code] && field.required !== false) emptyRequiredInputs.push(field.code);
                })

                if (emptyRequiredInputs.length > 0) {
                    this.handleRequiredError(emptyRequiredInputs);

                    return;
                }

                this.$store.dispatch('triggerModalCallback', this.values);
                this.closeOpenModal();
            },

            handleRequiredError(emptyRequiredInputs) {
                this.warning = `Please fill out all required fields ${!!this.selectedLang ? 'in all required languages': ''}`;

                emptyRequiredInputs.map(idToTarget => {
                    $(`#${idToTarget}`).addClass("input-required");
                })
            },

            removeInputRequired(id) {
                this.warning = '';

                $(`#${id}`).removeClass("input-required");
            }
        }
    }
</script>

<style lang="scss">
    .superadmin-custom-form {
        .label {
            display: flex;
            align-items: center;
            padding: 0 0 8px;

            text-align: left;
            font-weight: bold;
            font-size: 12px;
            line-height: 16px;
            color: $black-1;

            .icon-container {
                margin-left: 8px;

                .tool-tip {
                    width: 300px;
                    align-items: flex-start;
                    font-weight: normal;
                }
            }
        }

        input {
            width: 100%;

            display: inline-block;
            border: 1px solid #ccc;
            margin-bottom: 10px;
            padding: 10px 17px;
            -o-border-radius: 2px;
            -webkit-border-radius: 2px;
            -moz-border-radius: 2px;
            border-radius: 2px;
            margin-right: 10px;

            &.input-required {
                border-color: rgba($error, .5);
                background: rgba($error, .1)
            }
        }

        textarea {
            min-height: 100px;
            font-size: 14px;
        }

        .button-container {
            margin-right: 16px;

            &:last-of-type {
                margin-right: 0;
            }
        }
    }
</style>